var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-picker',{class:'input border mr-4',attrs:{"type":"week","format":"DD-MM-YYYY"},on:{"change":_vm.updateValues},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}})}
var staticRenderFns = []

export { render, staticRenderFns }